module.exports = __webpack_public_path__ + "img/phone.6391d486.png";